export type ReasonToDelete = {
  id: number;
  titleAr: string;
  titleEn: string;
  isEditable: boolean;
};

export type DeleteDialogState = 'confirm' | 'system-defined' | 'in-use' | 'closed';

export type ApiErrorResponse = {
  code: string;
  messageEn: string;
  messageAr: string;
  reqBodyErrors?: string[];
};

export const DELETE_REASON_ERROR_CODES = {
  REASON_NOT_FOUND: 'REASON_NOT_FOUND',
  REASON_IN_USE: 'REASON_IN_USE',
  REASON_NOT_EDITABLE: 'REASON_NOT_EDITABLE',
  CANNOT_DELETE_SYSTEM_REASON: 'CANNOT_DELETE_SYSTEM_REASON',
} as const;
